import { slugKey } from "@/lib/Listing/MobileFilterHelpers.js"

const ARRAY_PARAMS = ["medium", "price", "size", "orientation", "style", "colour", "collection", "location"]

const panelParamName = (panel) => ({ prices: "price", sizes: "size" })[panel] ?? panel.replace(/s$/, "")

// The form as it would submit, in plain data — unchecked boxes simply aren't
// in FormData, so the counting below stays free of the DOM.
export function readFilterState(form) {
  const data = new FormData(form)
  const checked = Object.fromEntries(ARRAY_PARAMS.map((name) => [name, data.getAll(`${name}[]`)]))

  return {
    checked,
    sort: data.get("sort"),
    readyToHang: data.has("ready_to_hang"),
    fromFolloweds: data.has("from_followeds"),
    excludeSold: data.has("availability"),
    // Two inputs share the name: a hidden "false" plus the checkbox's "true".
    framing: data.getAll("framing_filter_preference").includes("true"),
    customPriceRange: Boolean(data.get("price_min") || data.get("price_max")),
    customDimensions: ["width_min", "width_max", "height_min", "height_max"].some((name) => data.get(name)),
  }
}

export function panelCount(panel, state, categoryMediums, { forTotal = false } = {}) {
  switch (panel) {
    case "categories":
      return categoriesCount(state, categoryMediums)
    case "sort":
      return state.sort && state.sort !== "relevant" ? 1 : 0
    case "display":
      return displayCount(state, forTotal)
    case "prices":
      return pricesCount(state)
    case "sizes":
      return sizesCount(state)
    default:
      return state.checked[panelParamName(panel)]?.length ?? 0
  }
}

// A category counts as one filter when the checked mediums exactly match it.
function categoriesCount(state, categoryMediums) {
  const selected = slugKey(state.checked.medium)
  const matchesCategory = Object.entries(categoryMediums).some(
    ([name, slugs]) => name !== "All Art" && slugs.length > 0 && slugKey(slugs) === selected,
  )
  return matchesCategory ? 1 : 0
}

// "Exclude sold" is on by default, so it only counts as a chosen filter, not toward the total.
function displayCount(state, forTotal) {
  const hangAndFollow = (state.readyToHang ? 1 : 0) + (state.fromFolloweds ? 1 : 0)
  const excludeSold = !forTotal && state.excludeSold ? 1 : 0
  return hangAndFollow + excludeSold
}

// A custom range hides the presets, so count one or the other, plus framing.
function pricesCount(state) {
  const presets = state.customPriceRange ? 0 : state.checked.price.length
  return presets + (state.customPriceRange ? 1 : 0) + (state.framing ? 1 : 0)
}

// A custom width/height hides the presets, so count one or the other.
function sizesCount(state) {
  const presets = state.customDimensions ? 0 : state.checked.size.length
  return presets + (state.customDimensions ? 1 : 0)
}
